<template>
  <button ref="button" class="button is-dark is-small" :data-clipboard-text="value">
    <i class="material-icons">&#xE14D;</i>
    <span>{{ $t('ui.buttons.copy') }}</span>
  </button>
</template>

<script>
import Clipboard from 'clipboard/dist/clipboard';
import notifications from 'services/Notifications';

export default {
  props: {
    value: {
      type: String,
      required: true,
      default: '',
    },
  },

  mounted() {
    const clipboard = new Clipboard(this.$refs.button); // '.media button'
    clipboard.on('success', data =>
      notify(
        this.$t('ui.notifications.types.success'),
        this.$t('ui.notifications.copy.success'),
        data.text
      )
    );
    clipboard.on('error', data =>
      notify(
        this.$t('ui.notifications.types.warning'),
        this.$t('ui.notifications.copy.error')
      )
    );
  },
};

function notify(type, message, data = '') {
  notifications.add(message + ' ' + data, type);
  console.log(message, data);
}
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.button {
  padding-left: 0.3125rem;
  padding-right: 0.3125rem;
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.32);
}

i {
  display: flex;
  font-size: $size-small;
  margin-right: 0.3125rem;
}
</style>